import React, {useEffect, useState, useRef} from 'react'
import {Link, useHistory, useParams} from 'react-router-dom'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol, CCollapse,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CLabel,
  CInputGroupAppend
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import Users from '../../../models/Users'
import ReCAPTCHA from "react-google-recaptcha";

const Login = (props) => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [errors, setErrors] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  useEffect(() => {
    if (localStorage.token || sessionStorage.token) {
      history.push("/")
    }

    if(props.location?.state?.inactive) {
      alert('You have been automatically logged out due to inactivity')
    }
  }, [])


  const submit = async () => {


    if(!captchaToken) setErrors("Please verify that you are not a robot");
    if (!password) setErrors("Password cannot be blank");
    if (!username) setErrors("Username cannot be blank");

    if (username && password && captchaToken) {
      setErrors("");
      try {

        let user = new Users();

        let result = await user.login({
          username: username,
          password: password,
          captcha_token: captchaToken,
          mode: process.env.NODE_ENV
        })

        console.log(result)

        if (remember) {
          localStorage.role = result.role;
          localStorage.token = result.token
        } else {
          sessionStorage.role = result.role;
          sessionStorage.token = result.token;
        }


        history.push("/")
      } catch (e) {
        recaptchaRef.current.reset()
        console.log(e)

        if (e.code === "CREDENTIAL_NOT_FOUND") {
          setErrors("Incorrect username or password")
        }

        else if (e.code === "ACCOUNT_SUSPENDED") {
          setErrors("This account is suspended, please contact admin")
        }

        else if (e.code === "TOO_MANY_ATTEMPTS") {
          setErrors("Too many failed attempt. This account is now suspended, please contact admin")
        }

        else{
          setErrors("An Error Occured")
        }
      }
    }
  }

  const onKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      ev.preventDefault();

      submit()
    }
  }

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="4">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm>
                    <h1>Login</h1>
                    <p className="text-muted">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-user"/>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        placeholder="Username"
                        autoComplete="username"
                        onKeyPress={onKeyPress}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-lock-locked"/>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput type="password" placeholder="Password" autoComplete="current-password"
                              onKeyPress={onKeyPress}
                              onChange={(e) => setPassword(e.target.value)}
                      />
                    </CInputGroup>
                    <CInputGroupText style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: '1em'
                    }}>
                      <input
                        onChange={(e) => {
                          // console.log(e.target.value)
                          setRemember(!remember)
                        }}
                        type="checkbox" value={remember} id="defaultCheck1"/>
                      <label
                        style={{
                          marginLeft: 10,
                        }}
                        class="form-check-label">
                        Remember Me
                      </label>
                      {/*<CInput*/}
                      {/*  style={{*/}
                      {/*    width : 75,*/}
                      {/*    backgroundColor : "yellow",*/}
                      {/*    color : "red",*/}
                      {/*    size : 20,*/}
                      {/*    height : 30,*/}
                      {/*  }}*/}
                      {/*  type="checkbox"*/}
                      {/*  size={"xs"}*/}
                      {/*  onChange={()=> setRemember(!remember)}/>*/}
                    </CInputGroupText>

                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.NODE_ENV === 'production' ? "6Le3B08aAAAAAEi7QUayB4KrHnaEeU-0vPIhcPVe" : "6LfDB08aAAAAAJqU-cgvvd_F3NDc07FMRLl7E1Cw"}
                      onChange={(value) => setCaptchaToken(value)}
                      onExpired={() => setCaptchaToken(null)}
                    />
                    <CCollapse
                      style={{marginTop: "1em"}}
                      show={errors} timeout={1000}>
                      <CAlert color="danger">{errors}</CAlert>
                    </CCollapse>
                    <CRow>
                      <CCol xs="10">
                        <br/>
                        <CButton color="primary" className="px-4" onClick={submit}>Login</CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              {/*<CCard className="text-white bg-primary py-5 d-md-down-none" style={{width: '44%'}}>*/}
              {/*  <CCardBody className="text-center">*/}
              {/*    <div>*/}
              {/*      <Link to="/register">*/}
              {/*        <CButton color="primary" className="mt-3" active tabIndex={-1}>Register Now!</CButton>*/}
              {/*      </Link>*/}
              {/*    </div>*/}
              {/*  </CCardBody>*/}
              {/*</CCard>*/}
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )


}

export default Login
